import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ApiService } from 'src/app/services/api/api.service';
import { HyperLinkService } from 'src/app/services/utilitys/utilitys.service';

@Component({
  selector: 'app-comment-textarea',
  templateUrl: './comment-textarea.component.html',
  styleUrls: ['./comment-textarea.component.scss']
})
export class CommentTextareaComponent implements OnInit {
  memberSelected = [];
  caption: any = "";
  captemp;
  avatarTemplate;
  mentionConfig = {
    disableSearch: true,
    api: this.api,
    memberSelected: this.memberSelected,
    labelKey: 'Name',
    mentionSelect: this.onMentionSelect,
    allowSpace: true
  };

  captionCount = 0;
  @Input() item: any = {
    ID: ''
  };

  // tslint:disable-next-line:no-output-on-prefix
  @Output() onText = new EventEmitter();
  @Output() KeyUp = new EventEmitter();

  body = {
    departmentId: '',
    Id: '',
    mention: '',
    search: '',
    groupId: '',
    companyId: '',
  };
  captionHTML: any = '';
  mentionItems = [];
  constructor(
    private api: ApiService,
    private hyperlink: HyperLinkService
  ) { }

  ngOnInit() {

  }
  prese() {

  }
  keyup(e) {
    this.captemp = this.caption;
  }

  saveCaption() {
    this.captemp = this.caption;
    let capt = this.captemp.replaceAll('</div>', ' ');
    capt = capt.replaceAll('<div>', '\r\n');
    capt = capt.replaceAll('<br>', '\r\n');
    capt = capt.replaceAll('\r\n\r\n', '\r\n');
    capt = capt.replaceAll('&nbsp;', '\r\n')
    window.localStorage.setItem('caption', this.caption);
    window.localStorage.setItem('memberSelected', JSON.stringify(this.memberSelected));

    let userid = '';

    const temp = JSON.parse(JSON.stringify(this.memberSelected));
    temp.forEach((element, index) => {
      const indexSelected = this.captemp.indexOf(element.Name);
      if (indexSelected === -1) {
        this.memberSelected.splice(index, 1);
        this.clearMention(this.memberSelected);
      }
    });

    this.memberSelected.forEach((element, index) => {
      userid += element.UserId;
      if (index !== this.memberSelected.length - 1) {
        userid += ',';
      }
    });

    this.onText.emit({
      caption: capt,
      mentions: userid,
      mentionList: this.memberSelected,
      captionCount: this.captionCount,
      item: this.item
    });
    this.setMentionStyle();
  }
  async onSearchTerm(searchString: string) {
    this.body.search = searchString;

    this.fetchMention();

  }

  onMentionSelect(selection: any) {
    const index = this.memberSelected.findIndex((mem: any) => {
      return (mem.UserId || mem.UserID) === (selection.UserId || selection.UserID);
    });

    if (index === -1) {
      this.memberSelected.push(selection);
    }

    return selection.Name;
  }
  fetchMention() {
    this.api.expGetUserMention(this.body)
      .then(res => {
        if (res) {
          this.mentionItems = res.Results;
        }
      });
  }
  setMentionStyle() {
    if (this.captemp) {
      const capt = this.captemp.replaceAll('\r\n', '<br>');
      this.captionHTML = this.hyperlink.replaceMentionHTML(this.memberSelected, capt);
      setTimeout(() => {
        const textarea = document.getElementById('comment-post-' + this.item.ID);
        document.getElementById('post-mark' + this.item.ID).scrollTop = textarea.scrollTop;
      }, 0);

    } else {
      this.captionHTML = '';
      this.captemp = '';
    }
  }
  onScroll(e) {
    document.getElementById('post-mark' + this.item.ID).scrollTop = e.target.scrollTop;
  }
  clearMention(selected) {
    // if (!this.FeedID) {
    //   this.memberSelected = selected ? selected : [];
    // }

    this.mentionConfig = {
      disableSearch: true,
      api: this.api,
      memberSelected: this.memberSelected,
      labelKey: 'Name',
      mentionSelect: this.onMentionSelect,
      allowSpace: true
    };
  }

  textTrigger() {
    var text = this.caption;
    this.captionHTML = this.applyHighlights(text);
  }

  applyHighlights(text) {
    return text
      .replace(/\n$/g, '\n\n')
      .replace(/[A-Z].*?\b/g, '<mark></mark>');
  }
  onNameChange(event) {
    event.preventDefault();
    const message = event.target.innerHTML;
    if (event.target.innerHTML.length > 1000) {
      event.preventDefault();
    }
    this.captionCount = this.removeTags(message);
    this.caption = message;
    this.saveCaption();
    this.autogrow();
  }

  removeTags(str) {
    if ((str === null) || (str === ''))
      return 0;
    else
      str = str.toString();

    // Regular expression to identify HTML tags in 
    // the input string. Replacing the identified 
    // HTML tag with a null string.
    return str.replace(/(<([^>]+)>)/ig, '').length;
  }

  autogrow() {

    const textArea = document.getElementById('caption' + this.item.ID);
    const textArea2 = document.getElementById('comment-post-' + this.item.ID);
    textArea.style.height = 'auto';
    textArea.style.height = textArea2.scrollHeight + 'px';
    
  }

}

